import { useState } from "react";

// TruncatedId component for displaying truncated ID with tooltip
const TruncatedText = ({
  text,
  maxLength = 6,
  textClasses = "text-gray-1",
}: {
  text: string | undefined;
  maxLength?: number;
  textClasses?: string;
}) => {
  if (!text) text = "";

  const [showFullId, setShowFullId] = useState(false);
  const truncatedId =
    text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;

  return (
    <div className="relative inline-block">
      <span
        className={`cursor-pointer ${textClasses}`}
        onMouseEnter={() => setShowFullId(true)}
        onMouseLeave={() => setShowFullId(false)}
        onClick={() => setShowFullId(!showFullId)}
      >
        {truncatedId}
      </span>
      {showFullId && text.length > maxLength && (
        <div className="absolute z-10 p-2 bg-gray-800 text-white text-sm rounded shadow-lg top-full left-0 mt-1">
          {text}
        </div>
      )}
    </div>
  );
};

export default TruncatedText;
